<template>
	<div class="radio-stats">
		<div class="container">
			<div class="columns">
				<div class="column">
					<h4>Listeners (Live/Peak)</h4>
					<span class="stat">{{ stats.currentListeners + ` (` + stats.peakListeners + `)` }}</span>
				</div>

				<div class="column">
					<h4>Average listen time</h4>
					<Timer :timesince="stats.averageListenTime" :iscalculated="true" :countdown="false"></Timer>
				</div>

				<div class="column">
					<h4>Time since last repeat</h4>
					<Timer :title="getLastRepeatInfo()" :timesince="repeatinfo.last_repeat" :countdown="false"></Timer>
				</div>

				<div class="column">
					<h4>No repeat record</h4>
					<Timer :timesince="repeatinfo.no_repeat_record" :iscalculated="shouldRepeatRecordTick()" :countdown="false" :shouldtick="shouldRepeatRecordTick()"></Timer>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Timer from '@/components/globals/Timer';

	export default {
		name: 'radiostats',
		
		components: {
			Timer
		},

		data () {
			return {
			}
		},

		props: {
			repeatinfo: Object,
			stats: Object
		},

		methods: {
			getLastRepeatInfo () {
				return this.$moment(this.repeatinfo.last_repeat * 1000).format(`[${this.repeatinfo.last_repeat_artist} - ${this.repeatinfo.last_repeat_track} on] MMMM Do YYYY [at] h:mm:ss a`);
			},

			shouldRepeatRecordTick () {
				var now = (new Date().getTime() / 1000), timeSinceLastRepeat = (now - this.repeatinfo.last_repeat);
				if (timeSinceLastRepeat >= this.repeatinfo.no_repeat_record) {
					return true;
				}

				return false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.radio-stats {
		align-items: center;
		border-bottom: 1px solid $default-border-col;
		clear: both;
		display: flex;
		float: left;
		justify-content: center;
		padding: 20px 0;
		width: 100%;

		h4 {
			font-weight: bold;
			text-align: center;
		}

		.timer {
			text-align: center;
		}

		.container {
			height: 100%;
			overflow: hidden;
		}

		.columns {
			margin-bottom: 0;
		}

		.stat {
			clear: both;
			display: inline-block;
			float: left;
			text-align: center;
			width: 100%;
		}
	}

	body.is-dark {
		.radio-stats {
			border-color: $dark-border-color;
		}
	}
</style>



// WEBPACK FOOTER //
// RadioStats.vue?162ac47b